<style lang="less" scoped>
@import '../../../style/common/variable';
.listDouble {position: relative;width: 810px;height: 180px;margin-top: 10px;text-align: left;font-family: AlibabaPuHuiTi-Regular;}
.type{margin: 44px 0px 0px 0px;padding-top:5px;
  .left{float: left;
    .icon{display: inline-block;width: 10px;height: 18px;background-color: rgb(9, 182, 250);margin: 0px 10px -2px 0px;vertical-align: baseline;}
    span{font-size: 18px;font-weight: 600;}
  }
  .right{float: right;cursor: pointer;
    span{font-size: 14px;font-weight: 600;}
    span:hover{opacity: .7;}
  }
}
ul{list-style: none;margin-left: -40px;margin-top: 30px;margin-left: -40px;height: 130px;overflow: hidden;}
li::before {content: "●";margin-right: 5px;}
li {font-size: 14px;margin-top: 12px;width: 280px;margin-right: 120px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;float: left;}
li:hover {color: #13569e;;cursor: pointer;}
/* 移动端适配 */
@media screen and (max-width: @max-screen) {
  .listDouble {height: auto;
    .type{width: 95vw;}
    ul{width: 100vw; height: auto;
      li{width: 90vw;margin-left: 5vw;}
    }
  }
}
</style>

<!--何宽  2021.7.3
    该组件使用场景：将标题以列表的形式分两列 纵向展示，只展示4行数据。鼠标点击标题，将 相应的对象 传递给父组件 -->
<template>
  <div class="listDouble">
    <div class="type">
      <div class="left">
        <div class="icon"></div><span>{{ listDouble.type }}</span>
      </div>
      <div class="right">
        <span @click="getmore(listDouble)">{{ listDouble.button }}</span>
      </div>
    </div>
    <ul>
      <li v-for="(item, index) in listDouble.listdata.slice(0, 8)" :key="index" @click="clickList(item)">
        <span>{{ item.title }}</span>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['listDouble'],
  data()
  {
    return {}
  },
  mounted()
  {
    console.log(this.props)
  },
  methods: {
    // 点击更多，将对应的类型对象传递给父组件
    getmore(listDouble)
    {
      this.$emit('getmore', listDouble)
    },
    // 点击列表项，并将选中的 li对象 传递给父组件
    clickList(item)
    {
      this.$emit('clickList', item)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/ListDouble.vue